import { ILocale, ITranslationState } from './models'

export const NAME = `translation`

export enum TranslationMode {
  Edit = 'edit',
  View = 'view',
}

export const defaultLocale: ILocale = {
  value: 'en',
  name: 'English-Global',
}

export const initialState: ITranslationState = {
  locale: defaultLocale,
  defaultLocale,
  isDefaultLocale: true,
  isInitialized: false,
  mode: TranslationMode.View,
}
